import _ from 'lodash'
import { CASINO_PROVIDERS_PER_PAGE } from '@/config/casino'
import { resolvePlayerAssetUrl } from '@/lib/player-api'
import { useGetCasinoProvidersQuery } from '@/store/api/casinoApi'
import type { CasinoProvider } from '@/types/casino'

function ProviderLogo({ provider }: { provider: CasinoProvider }) {
	if (provider.logo_url) {
		return (
			<img src={resolvePlayerAssetUrl(provider.logo_url)} alt={provider.provider_name} className='h-7 w-auto max-w-[140px] object-contain opacity-50 brightness-0 invert' />
		)
	}

	return <span className='whitespace-nowrap text-sm font-semibold tracking-wide text-foreground/40'>{provider.provider_name}</span>
}

function StripTrack({ providers, ariaHidden }: { providers: CasinoProvider[]; ariaHidden?: boolean }) {
	return (
		<div className='flex shrink-0 items-center gap-16 px-8' aria-hidden={ariaHidden}>
			{_.map(providers, (provider) => (
				<div key={`${ariaHidden ? 'dup' : 'src'}-${provider.id}`} className='flex shrink-0 items-center justify-center'>
					<ProviderLogo provider={provider} />
				</div>
			))}
		</div>
	)
}

export function ProviderStrip() {
	const { data, isLoading, isError } = useGetCasinoProvidersQuery({
		page: 1,
		per_page: CASINO_PROVIDERS_PER_PAGE,
	})

	const providers = data?.data ?? []

	if (isLoading || isError || _.isEmpty(providers)) {
		return null
	}

	return (
		<div className='overflow-hidden rounded-2xl border border-foreground/[0.02] bg-card py-6'>
			<div className='flex w-max animate-strip hover:[animation-play-state:paused]'>
				<StripTrack providers={providers} />
				<StripTrack providers={providers} ariaHidden />
			</div>
		</div>
	)
}
